module.exports = __webpack_public_path__ + "50f36aed067234570f7f4b15b5566ed4.png";